/**
 *
 * FBFormsPreviewAnswer
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// layout components
import Preloader from 'components/Preloader';
import ErrorBoundary from 'engine/ErrorBoundary';

// mobile communication components
import {
  FBFormsAnswer
} from 'mobile/components/Communications';


function FBFormsPreviewAnswer({
  type,
  values,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-forms-group-preview', 'tcf-fb-group-preview', 'tcf-fb-group-answer-preview', className);

  const [answers, setAnswers] = useState(values?.answer[type]?.data || []);
  const [forms, setForms] = useState(values?.[type] || {});


  // Refresh current value based on parent`s states
  useEffect(() => {
    if (!!values) {
      if (JSON.stringify(values?.answer[type]?.data) != JSON.stringify(answers)) {
        setAnswers(values?.answer[type]?.data || []);
      }
      if (JSON.stringify(values?.[type]) != JSON.stringify(forms)) {
        setForms(values?.[type] || {});
      }
    } else if (!!!values) {
      setForms([]);
      setAnswers([]);
    }
  }, [values]);

  return !!values && (
    <div {...rest} className={childClassNames}>
      <div className='tcf-fb-group-preview__content'>
        <ErrorBoundary>
          {values?.forms && (
            <FBFormsAnswer
              forms={values?.[type]}
              values={values?.answer?.[type]?.data}
              actionRequired={false}
              showHeader={false}
            />
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
}

FBFormsPreviewAnswer.defaultProps = {
  type: 'forms',
};
FBFormsPreviewAnswer.propTypes = {
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.bool, PropTypes.array])
};

export default memo(FBFormsPreviewAnswer);
